import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IASEntryCreateParams } from "../models/shortage";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Update All Shortage entry and return same object
 */

export const UpdateASEntryAPI = async (params: IASEntryCreateParams, osdNumber?: number | string) => {
  try {
    const response = await axios.put(`${getUrl(ApiType.AS_ENTRY_UPDATE)}/${osdNumber}`, params);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.updateASEntry, { badRequestOrder: "errorsFirst" });
  }
};
